import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-587dc39d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-breadcrumb__area pt-25 pb-55 p-relative z-index-1 fix" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tp-breadcrumb__bg",
  "data-background": "/assets/lms_website/website-assets/img/breadcrumb/breadcrumb-bg-2.jpg"
}, null, -1 /* HOISTED */))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-sm-12" }
const _hoisted_6 = {
  class: "tp-breadcrumb__content",
  style: {"min-height":"270px"}
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center gap-1 mt-4 placeholder-glow\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:120px;height:26px;\" data-v-587dc39d></span></div><div class=\"d-flex align-items-center gap-1 mt-3 placeholder-glow\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:50%;height:15px;\" data-v-587dc39d></span></div><div class=\"d-flex align-items-center gap-4 mt-4 placeholder-glow\" data-v-587dc39d><div class=\"d-flex align-items-center gap-1\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:50px;height:50px;\" data-v-587dc39d></span><div data-v-587dc39d><span class=\"placeholder d-block rounded mb-1\" style=\"width:60px;height:10px;\" data-v-587dc39d></span><span class=\"placeholder d-block rounded\" style=\"width:100px;height:15px;\" data-v-587dc39d></span></div></div><div data-v-587dc39d><span class=\"placeholder d-block rounded mb-1\" style=\"width:50px;height:10px;\" data-v-587dc39d></span><span class=\"placeholder d-block rounded\" style=\"width:100px;height:15px;\" data-v-587dc39d></span></div><div data-v-587dc39d><span class=\"placeholder d-block rounded mb-1\" style=\"width:50px;height:10px;\" data-v-587dc39d></span><span class=\"placeholder d-block rounded\" style=\"width:100px;height:15px;\" data-v-587dc39d></span></div><div data-v-587dc39d><span class=\"placeholder d-block rounded mb-1\" style=\"width:50px;height:10px;\" data-v-587dc39d></span><span class=\"placeholder d-block rounded\" style=\"width:100px;height:15px;\" data-v-587dc39d></span></div></div>", 3)
const _hoisted_10 = {
  key: 1,
  class: "tp-course-details-2-header mt-4"
}
const _hoisted_11 = { class: "tp-course-details-2-category" }
const _hoisted_12 = { class: "tp-course-details-2-title" }
const _hoisted_13 = { class: "tp-course-details-2-meta-wrapper d-flex align-items-center flex-wrap" }
const _hoisted_14 = { class: "tp-course-details-2-meta" }
const _hoisted_15 = {
  key: 0,
  class: "tp-course-details-2-author d-flex align-items-center"
}
const _hoisted_16 = { class: "tp-course-details-2-author-avater" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "tp-course-details-2-author-content" }
const _hoisted_19 = { class: "tp-course-details-2-author-designation" }
const _hoisted_20 = { class: "tp-course-details-2-meta-title" }
const _hoisted_21 = { class: "tp-course-details-2-meta" }
const _hoisted_22 = { class: "tp-course-details-2-meta-subtitle" }
const _hoisted_23 = { class: "tp-course-details-2-meta-title" }
const _hoisted_24 = { class: "tp-course-details-2-meta" }
const _hoisted_25 = { class: "tp-course-details-2-meta-subtitle" }
const _hoisted_26 = { class: "tp-course-details-2-meta-title" }
const _hoisted_27 = { class: "tp-course-details-2-meta text-end" }
const _hoisted_28 = { class: "tp-course-details-2-meta-rating-wrapper" }
const _hoisted_29 = { class: "tp-course-rating-icon" }
const _hoisted_30 = { class: "course-star-rating" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"back-stars\" data-v-587dc39d><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i></div>", 1)
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i><i class=\"fa fa-star\" data-v-587dc39d></i>", 5)
const _hoisted_37 = [
  _hoisted_32
]
const _hoisted_38 = { class: "tp-course-details-2-meta-subtitle" }
const _hoisted_39 = { class: "tp-course-details-2-area pt-50 pb-80" }
const _hoisted_40 = { class: "container" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-8" }
const _hoisted_43 = {
  key: 0,
  class: "tp-course-details-2-main-inner pr-70 placeholder-glow"
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"placeholder d-block rounded mt-2\" style=\"width:100%;height:15px;\" data-v-587dc39d></div><div class=\"placeholder d-block rounded mt-2\" style=\"width:100%;height:15px;\" data-v-587dc39d></div><div class=\"placeholder d-block rounded mt-2\" style=\"width:100%;height:15px;\" data-v-587dc39d></div><div class=\"d-flex align-items-center gap-1 mt-2\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:50%;height:15px;\" data-v-587dc39d></span></div>", 4)
const _hoisted_48 = [
  _hoisted_44
]
const _hoisted_49 = {
  key: 1,
  class: "tp-course-details-2-main-inner pr-70"
}
const _hoisted_50 = { class: "tp-course-details-2-nav d-flex align-items-center" }
const _hoisted_51 = {
  class: "d-flex gap-1",
  id: "course_details2_nav"
}
const _hoisted_52 = { class: "current" }
const _hoisted_53 = { href: "#info" }
const _hoisted_54 = { class: "" }
const _hoisted_55 = {
  key: 0,
  href: "#resources"
}
const _hoisted_56 = { class: "" }
const _hoisted_57 = { href: "#curriculum" }
const _hoisted_58 = { class: "" }
const _hoisted_59 = { href: "#reviews" }
const _hoisted_60 = { class: "tp-course-details-2-content" }
const _hoisted_61 = { id: "info" }
const _hoisted_62 = { class: "tp-course-details-2-main-title" }
const _hoisted_63 = { class: "tp-course-details-2-text mb-60" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "tp-course-details-showmore show-more-button" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M6 1V11",
      stroke: "#3C66F9",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 6H11",
      stroke: "#3C66F9",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1 /* HOISTED */))
const _hoisted_67 = {
  key: 0,
  id: "resources"
}
const _hoisted_68 = { class: "tp-course-details-2-main-title" }
const _hoisted_69 = { class: "tp-course-details-2-text mb-60" }
const _hoisted_70 = { class: "list-group" }
const _hoisted_71 = ["href"]
const _hoisted_72 = { class: "text-dark" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-external-link text-secondary" }, null, -1 /* HOISTED */))
const _hoisted_74 = { class: "col-lg-4" }
const _hoisted_75 = {
  key: 0,
  class: "tp-course-details-2-widget placeholder-glow"
}
const _hoisted_76 = /*#__PURE__*/_createStaticVNode("<div data-v-587dc39d><span class=\"placeholder d-block rounded\" style=\"width:100%;height:235px;\" data-v-587dc39d></span></div><div class=\"d-flex align-items-center gap-1 mt-3\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:100px;height:30px;\" data-v-587dc39d></span></div><div class=\"d-flex align-items-center gap-1 mt-3\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:100%;height:15px;\" data-v-587dc39d></span></div><div class=\"d-flex align-items-center gap-1 mt-2\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:50%;height:15px;\" data-v-587dc39d></span></div>", 4)
const _hoisted_80 = [
  _hoisted_76
]
const _hoisted_81 = {
  key: 1,
  class: "tp-course-details-2-widget"
}
const _hoisted_82 = { class: "tp-course-details-2-widget-thumb p-relative" }
const _hoisted_83 = ["src", "alt"]
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "tp-course-details-2-widget-content" }
const _hoisted_86 = { class: "tp-course-details-2-widget-price" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = {
  key: 1,
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_89 = { class: "d-block" }
const _hoisted_90 = { key: 1 }
const _hoisted_91 = {
  key: 0,
  class: "badge bg-success font-w-400 font-s-14"
}
const _hoisted_92 = { class: "tp-course-details-2-widget-btn" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  "aria-hidden": "true"
}
const _hoisted_96 = { class: "tp-course-details-2-widget-list" }
const _hoisted_97 = { class: "tp-course-details-2-widget-list-item-wrapper" }
const _hoisted_98 = { class: "tp-course-details-2-widget-list-item d-flex align-items-center justify-content-between" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.5 1C12.6415 1 16 4.35775 16 8.5C16 12.6423 12.6415 16 8.5 16C4.35775 16 1 12.6423 1 8.5C1 4.35775 4.35775 1 8.5 1Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.8692 8.49618C10.8692 7.85581 7.58703 5.80721 7.2147 6.17556C6.84237 6.54391 6.80657 10.4137 7.2147 10.8168C7.62283 11.2213 10.8692 9.13655 10.8692 8.49618Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_100 = { class: "tp-course-details-2-widget-list-item d-flex align-items-center justify-content-between" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 3.80005V8.00005L10.8 9.40005",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_102 = { class: "tp-course-details-2-widget-list-item d-flex align-items-center justify-content-between" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.721 6.64274C14.721 7.8116 14.3744 8.88373 13.7779 9.77851C12.9073 11.0683 11.5289 11.9792 9.9247 12.2129C9.65063 12.2613 9.36849 12.2855 9.07829 12.2855C8.78809 12.2855 8.50596 12.2613 8.23188 12.2129C6.62773 11.9792 5.24929 11.0683 4.37869 9.77851C3.78217 8.88373 3.43555 7.8116 3.43555 6.64274C3.43555 3.52311 5.95866 1 9.07829 1C12.1979 1 14.721 3.52311 14.721 6.64274Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M16.5341 14.2766L15.2041 14.591C14.9058 14.6636 14.672 14.8893 14.6075 15.1875L14.3254 16.3725C14.1722 17.0174 13.35 17.2109 12.9228 16.703L9.07766 12.2856L5.23253 16.7111C4.80529 17.2189 3.98307 17.0255 3.82991 16.3806L3.54777 15.1956C3.47522 14.8973 3.24145 14.6636 2.95125 14.5991L1.62117 14.2847C1.00853 14.1396 0.790885 13.3738 1.23424 12.9304L4.37806 9.78662C5.24865 11.0764 6.6271 11.9873 8.23125 12.2211C8.50532 12.2694 8.78746 12.2936 9.07766 12.2936C9.36786 12.2936 9.64999 12.2694 9.92407 12.2211C11.5282 11.9873 12.9067 11.0764 13.7773 9.78662L16.9211 12.9304C17.3644 13.3657 17.1468 14.1315 16.5341 14.2766Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M9.54557 4.20822L10.0212 5.15942C10.0857 5.2884 10.2549 5.41738 10.4081 5.44156L11.2706 5.58665C11.8188 5.67533 11.9478 6.07838 11.5528 6.47338L10.8837 7.14243C10.7709 7.25529 10.7064 7.47295 10.7467 7.63417L10.9401 8.46446C11.0933 9.11741 10.7467 9.37535 10.1663 9.02872L9.36017 8.55312C9.21507 8.46445 8.97324 8.46445 8.82814 8.55312L8.02203 9.02872C7.44163 9.36728 7.09501 9.11741 7.24817 8.46446L7.44163 7.63417C7.47388 7.48101 7.41745 7.25529 7.3046 7.14243L6.63553 6.47338C6.24054 6.07838 6.36951 5.68339 6.91766 5.58665L7.7802 5.44156C7.9253 5.41738 8.09458 5.2884 8.15907 5.15942L8.63467 4.20822C8.86844 3.69231 9.28762 3.69231 9.54557 4.20822Z",
    stroke: "#4F5158",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_104 = { class: "tp-course-details-2-widget-list-item d-flex align-items-center justify-content-between" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "15",
  viewBox: "0 0 13 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.57134 7.5C8.36239 7.5 9.81432 6.04493 9.81432 4.25C9.81432 2.45507 8.36239 1 6.57134 1C4.7803 1 3.32837 2.45507 3.32837 4.25C3.32837 6.04493 4.7803 7.5 6.57134 7.5Z",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.1426 14C12.1426 11.4845 9.64553 9.44995 6.57119 9.44995C3.49684 9.44995 0.999756 11.4845 0.999756 14",
    stroke: "#94928E",
    "stroke-width": "1.2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_106 = {
  key: 0,
  class: "tp-course-details-2-related-area pb-80"
}
const _hoisted_107 = { class: "container" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-course-details-2-related-border" }, null, -1 /* HOISTED */))
const _hoisted_109 = { class: "row" }
const _hoisted_110 = { class: "col-lg-12" }
const _hoisted_111 = { class: "tp-course-details-2-related-heading pt-80" }
const _hoisted_112 = { class: "tp-course-details-2-related-title" }
const _hoisted_113 = { class: "row" }
const _hoisted_114 = /*#__PURE__*/_createStaticVNode("<div class=\"tp-course-item p-relative fix mb-30 placeholder-glow\" data-v-587dc39d><div class=\"tp-course-teacher mb-15\" data-v-587dc39d><div class=\"d-flex align-items-center gap-1\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded-circle\" style=\"width:30px;height:30px;\" data-v-587dc39d></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-587dc39d></span></div></div><div class=\"tp-course-thumb\" data-v-587dc39d><span class=\"placeholder d-block rounded\" style=\"height:200px;\" data-v-587dc39d></span></div><div class=\"tp-course-content\" data-v-587dc39d><div class=\"d-flex align-items-center gap-1 mb-10\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:100px;height:25px;\" data-v-587dc39d></span></div><div class=\"tp-course-meta\" data-v-587dc39d><div class=\"d-flex align-items-center gap-1\" data-v-587dc39d><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-587dc39d></span><span class=\"placeholder d-inline-block rounded\" style=\"width:80px;height:10px;\" data-v-587dc39d></span></div></div><span class=\"placeholder d-block rounded mt-4 mb-1\" style=\"width:80%;height:6px;\" data-v-587dc39d></span><span class=\"placeholder d-block rounded\" style=\"width:30%;height:6px;\" data-v-587dc39d></span></div></div>", 1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = {
  class: "modal fade",
  id: "paymentModal",
  tabindex: "-1",
  "aria-labelledby": "paymentModalLabel",
  "aria-hidden": "true"
}
const _hoisted_117 = { class: "modal-dialog" }
const _hoisted_118 = { class: "modal-content" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "paymentModalLabel"
  }, "Payment"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_120 = { class: "modal-body" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-field": "card.number" }, null, -1 /* HOISTED */))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-field": "card.expiry" }, null, -1 /* HOISTED */))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { "data-field": "card.securityCode" }, null, -1 /* HOISTED */))
const _hoisted_126 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_127 = { class: "mb-3" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Card Number", -1 /* HOISTED */))
const _hoisted_129 = { class: "row" }
const _hoisted_130 = { class: "col-ms-6 mb-3" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Expiry (MM/YY)", -1 /* HOISTED */))
const _hoisted_132 = { class: "col-ms-6 mb-3" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "CVV", -1 /* HOISTED */))
const _hoisted_134 = { class: "mb-3" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Name on Card", -1 /* HOISTED */))
const _hoisted_136 = { class: "modal-footer" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CourseContent = _resolveComponent("CourseContent")
  const _component_CourseReview = _resolveComponent("CourseReview")
  const _component_CourseWidget = _resolveComponent("CourseWidget")

  return (_openBlock(), _createElementBlock("main", null, [
    _createCommentVNode(" course details breadcrumb start "),
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              ($data.loading_data)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_7
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              (!$data.loading_data)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString($setup.lms_website.__($data.course_details?.tags)), 1 /* TEXT */),
                    _createElementVNode("h3", _hoisted_12, _toDisplayString($setup.lms_website.__($data.course_details?.title)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        ($data.course_details?.instructor?.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("img", {
                                  class: "rounded",
                                  src: ($data.course_details?.instructor?.user_image)?$data.course_details?.instructor?.user_image:'/assets/lms_website/images/user.png',
                                  alt: "Salim Rana"
                                }, null, 8 /* PROPS */, _hoisted_17)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString($setup.lms_website.__('Teacher')), 1 /* TEXT */),
                                _createElementVNode("h3", _hoisted_20, [
                                  _createElementVNode("a", null, _toDisplayString($data.course_details?.instructor?.full_name), 1 /* TEXT */)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString($setup.lms_website.__('Category')), 1 /* TEXT */),
                        _createElementVNode("h3", _hoisted_23, _toDisplayString($setup.lms_website.__($data.course_details?.custom_course_category)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString($setup.lms_website.__('Last Updated')), 1 /* TEXT */),
                        _createElementVNode("h3", _hoisted_26, _toDisplayString($options.format_date($data.course_details?.modified)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("div", {
                                class: "front-stars",
                                style: _normalizeStyle('width:'+$options.avg_rating_width($data.course_details?.avg_rating))
                              }, _hoisted_37, 4 /* STYLE */)
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_38, [
                            _createTextVNode(_toDisplayString($setup.lms_website.__('Reviews')) + " ", 1 /* TEXT */),
                            ($data.reviews_count && $data.reviews_count>=0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("(" + _toDisplayString($data.reviews_count) + ")", 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course details breadcrumb end "),
    _createCommentVNode(" course details area start "),
    _createElementVNode("section", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            ($data.loading_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_48))
              : _createCommentVNode("v-if", true),
            (!$data.loading_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("nav", null, [
                      _createElementVNode("ul", _hoisted_51, [
                        _createElementVNode("li", _hoisted_52, [
                          _createElementVNode("a", _hoisted_53, _toDisplayString($setup.lms_website.__('Course Info')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("li", _hoisted_54, [
                          ($data.course_details?.resources?.length)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_55, _toDisplayString($setup.lms_website.__('Resources')), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("li", _hoisted_56, [
                          _createElementVNode("a", _hoisted_57, _toDisplayString($setup.lms_website.__('Content')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("li", _hoisted_58, [
                          _createElementVNode("a", _hoisted_59, _toDisplayString($setup.lms_website.__('Reviews')), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("h4", _hoisted_62, _toDisplayString($setup.lms_website.__('About Course')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", {
                          class: "content",
                          innerHTML: ($setup.lms_website.current_language==='ar')? ($data.course_details?.custom_description_arabic || $data.course_details?.description) : $data.course_details?.description
                        }, null, 8 /* PROPS */, _hoisted_64),
                        _createElementVNode("a", _hoisted_65, [
                          _hoisted_66,
                          _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Show More')), 1 /* TEXT */)
                        ])
                      ])
                    ]),
                    ($data.course_details?.resources?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createElementVNode("h4", _hoisted_68, _toDisplayString($setup.lms_website.__('Resources')) + " (" + _toDisplayString($data.course_details?.resources?.length) + ")", 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.course_details?.resources, (resource) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  key: resource.name,
                                  href: resource.url,
                                  target: "_blank",
                                  class: "list-group-item list-group-item-action d-flex align-items-center justify-between"
                                }, [
                                  _createElementVNode("span", _hoisted_72, _toDisplayString(resource.title), 1 /* TEXT */),
                                  _hoisted_73
                                ], 8 /* PROPS */, _hoisted_71))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($data.course_details && $data.course_details?.name)
                      ? (_openBlock(), _createBlock(_component_CourseContent, {
                          key: 1,
                          chapters: $data.course_chapters,
                          "course-enrolled": $data.course_enrolled
                        }, null, 8 /* PROPS */, ["chapters", "course-enrolled"]))
                      : _createCommentVNode("v-if", true),
                    ($data.course_details && $data.course_details?.name)
                      ? (_openBlock(), _createBlock(_component_CourseReview, {
                          key: 2,
                          "course-name": $data.course_details?.name,
                          "is-reviewed": $data.course_details?.is_reviewed,
                          "course-enrolled": $data.course_enrolled
                        }, null, 8 /* PROPS */, ["course-name", "is-reviewed", "course-enrolled"]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_74, [
            ($data.loading_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_75, _hoisted_80))
              : _createCommentVNode("v-if", true),
            (!$data.loading_data)
              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    (!$options.videoId || !$options.videoId?.length)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: ($data.course_details?.image)?$data.course_details?.image:'/assets/lms_website/images/placeholder.jpg',
                          alt: $data.course_details?.title
                        }, null, 8 /* PROPS */, _hoisted_83))
                      : _createCommentVNode("v-if", true),
                    ($options.videoId?.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("iframe", {
                            style: {"width":"100%","min-height":"230px","border":"0","border-radius":"8px"},
                            src: `https://www.youtube.com/embed/${$options.videoId}`,
                            allowFullscreen: "",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          }, null, 8 /* PROPS */, _hoisted_84),
                          _createCommentVNode("                  <a class=\"popup-video\" :data-video=\"videoId\">"),
                          _createCommentVNode("                    <span>"),
                          _createCommentVNode("                      <svg width=\"14\" height=\"18\" viewBox=\"0 0 14 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">"),
                          _createCommentVNode("                        <path d=\"M0 1.83167C0 1.0405 0.875246 0.562658 1.54076 0.990487L12.6915 8.15882C13.3038 8.55246 13.3038 9.44754 12.6915 9.84118L1.54076 17.0095C0.875246 17.4373 0 16.9595 0 16.1683V1.83167Z\" fill=\"#031F42\"/>"),
                          _createCommentVNode("                      </svg>"),
                          _createCommentVNode("                    </span>"),
                          _createCommentVNode("                  </a>")
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_85, [
                    _createElementVNode("div", _hoisted_86, [
                      (!$data.course_details?.paid_course)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString($setup.lms_website.__('Free')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($data.course_details?.paid_course)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createElementVNode("div", null, [
                              ($data.course_details?.custom_course_sale_price)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("del", _hoisted_89, _toDisplayString($options.format_currency($data.course_details.course_price)), 1 /* TEXT */),
                                    _createElementVNode("span", null, _toDisplayString($options.format_currency($data.course_details.custom_course_sale_price)), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString($options.format_currency($data.course_details?.course_price)), 1 /* TEXT */))
                            ]),
                            ($data.course_enrolled)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString($setup.lms_website.__('Paid')), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_92, [
                      ($data.course_details?.paid_course && !$data.course_enrolled)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            ($setup.lms_website.user_session && $setup.lms_website.user_session !== 'Guest')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("a", {
                                    class: "active pointer-event",
                                    onClick: _cache[0] || (_cache[0] = (...args) => ($options.initPayment && $options.initPayment(...args)))
                                  }, _toDisplayString($setup.lms_website.__('Buy Course')), 1 /* TEXT */),
                                  _createElementVNode("p", null, _toDisplayString($setup.lms_website.__('30-Day Money-Back Guarantee')), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  class: "active pointer-event",
                                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'auth.login', query: { redirect: _ctx.$route.fullPath } })))
                                }, _toDisplayString($setup.lms_website.__('Login to Buy')), 1 /* TEXT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      (!$data.course_details?.paid_course)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!$data.course_enrolled)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-primary w-100",
                                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.enroll_course && $options.enroll_course(...args))),
                                  disabled: $data.enroll_loading
                                }, [
                                  (!$data.enroll_loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString($setup.lms_website.__('Enroll Now')), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  ($data.enroll_loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_95))
                                    : _createCommentVNode("v-if", true)
                                ], 8 /* PROPS */, _hoisted_93))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createElementVNode("h5", null, _toDisplayString($setup.lms_website.__('This course includes:')), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("span", null, [
                            _hoisted_99,
                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Lectures')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", null, _toDisplayString($data.course_details?.lesson_count), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("span", null, [
                            _hoisted_101,
                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Duration')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", null, _toDisplayString($options.courseDuration), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("span", null, [
                            _hoisted_103,
                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Certificate')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", null, _toDisplayString(($data.course_details?.enable_certification) ? $setup.lms_website.__('Yes') : $setup.lms_website.__('No')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_104, [
                          _createElementVNode("span", null, [
                            _hoisted_105,
                            _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Students')), 1 /* TEXT */)
                          ]),
                          _createElementVNode("span", null, _toDisplayString($data.course_details?.enrollment_count), 1 /* TEXT */)
                        ]),
                        _createCommentVNode("                    <div class=\"tp-course-details-2-widget-search p-relative\">"),
                        _createCommentVNode("                      <form action=\"#\">"),
                        _createCommentVNode("                        <input type=\"text\" placeholder=\"Enter Coupon Code\">"),
                        _createCommentVNode("                        <button  type=\"submit\">Apply</button>"),
                        _createCommentVNode("                      </form>"),
                        _createCommentVNode("                    </div>")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" course details area end "),
    _createCommentVNode(" course details area start "),
    (!$data.loading_data)
      ? (_openBlock(), _createElementBlock("section", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _hoisted_108,
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("div", _hoisted_111, [
                  _createElementVNode("h3", _hoisted_112, _toDisplayString($setup.lms_website.__('Related Courses')), 1 /* TEXT */)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              (!$data.related_courses.is_loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($data.related_courses.list, (course) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6 animate__animated animate__zoomIn",
                      key: course.name
                    }, [
                      _createVNode(_component_CourseWidget, { course: course }, null, 8 /* PROPS */, ["course"])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              ($data.related_courses.is_loading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.range(1, 3), (number) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6",
                      key: number
                    }, _hoisted_115))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" course details area end "),
    _createCommentVNode("    <ConfirmModal"),
    _createCommentVNode("        :title=\"lms_website.__('Enroll Course')\""),
    _createCommentVNode("        @confirmed=\"enroll_course\""),
    _createCommentVNode("    />"),
    ($data.showModal)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "body"
        }, [
          _createCommentVNode(" Payment Modal "),
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("form", {
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers((...args) => ($options.initPayment && $options.initPayment(...args)), ["prevent"]))
                }, [
                  _hoisted_119,
                  _createElementVNode("div", _hoisted_120, [
                    (!$data.scriptLoaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_121, "Loading Mastercard..."))
                      : (_openBlock(), _createElementBlock("div", _hoisted_122, [
                          _hoisted_123,
                          _hoisted_124,
                          _hoisted_125,
                          _createElementVNode("button", {
                            class: "btn btn-dark btn-lg w-100",
                            onClick: _cache[3] || (_cache[3] = (...args) => ($options.submitCard && $options.submitCard(...args)))
                          }, "Submit Payment")
                        ])),
                    _createCommentVNode(" Error "),
                    ($data.payment.error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_126, _toDisplayString($data.payment.error), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_127, [
                      _hoisted_128,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.payment.card.number) = $event)),
                        class: "form-control",
                        type: "text",
                        placeholder: "1234 5678 9012 3456"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.payment.card.number]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.payment.card.expiry) = $event)),
                          class: "form-control",
                          type: "text",
                          placeholder: "MM/YY"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.payment.card.expiry]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_132, [
                        _hoisted_133,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.payment.card.cvv) = $event)),
                          class: "form-control",
                          type: "text",
                          placeholder: "123"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $data.payment.card.cvv]
                        ])
                      ])
                    ]),
                    _createCommentVNode(" Name on Card "),
                    _createElementVNode("div", _hoisted_134, [
                      _hoisted_135,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.payment.card.name) = $event)),
                        class: "form-control",
                        type: "text",
                        placeholder: "John Doe"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.payment.card.name]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _hoisted_137,
                    _createElementVNode("button", {
                      type: "submit",
                      onClick: _cache[8] || (_cache[8] = (...args) => ($options.payWithCard && $options.payWithCard(...args))),
                      class: "btn btn-success"
                    }, "Pay")
                  ])
                ], 32 /* NEED_HYDRATION */)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}